"use client";

import { ArrowUpRight, Download } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Consultation() {
  const {
    ref: line1Ref,
    isVisible: line1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: line2Ref,
    isVisible: line2Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  return <section data-section-id="3002" id="prenota-una-consulenza-specializzata" className="dark bg-background text-foreground relative overflow-hidden py-32 md:py-44 lg:py-56 px-6">
      {}
      <div className="absolute inset-0 bg-cover bg-center opacity-30 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1724194/img/medical_precision_care.png)]" aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background/70 to-background/40" aria-hidden="true" />

      <div className="relative max-w-6xl mx-auto">
        {}
        <div className="text-center mb-10 md:mb-14">
          <span className="font-mono text-xs md:text-sm tracking-[0.3em] uppercase" style={{
          color: "var(--chart-3)"
        }}>
            Prenotazione
          </span>
        </div>

        {}
        <div className="mb-12 md:mb-16">
          <div ref={line1Ref} className="overflow-hidden">
            <h2 className={`font-default font-light text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[96px] leading-[1.05] text-foreground transition-all duration-1000 ease-out ${line1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              La <span className="italic">precisione</span> della cura
            </h2>
          </div>
          <div ref={line2Ref} className="overflow-hidden mt-3 md:mt-4 md:pl-[80px]">
            <h2 className={`font-default font-light text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-[96px] leading-[1.05] text-foreground transition-all duration-1000 delay-200 ease-out ${line2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              richiede <span className="italic">ascolto</span>.
            </h2>
          </div>
        </div>

        {}
        <p ref={bodyRef} className={`text-center text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed mb-12 md:mb-16 transition-all duration-1000 delay-400 ease-out ${bodyVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          Inizia con una consulenza privata. Il Dott. Mirko Colloca riceve su appuntamento per garantire la massima attenzione clinica.
        </p>

        {}
        <div ref={ctaRef} className={`flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mb-20 md:mb-28 transition-all duration-1000 delay-500 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg px-8 py-7 text-base">
            <Link to="/ContactsPage">
              Richiedi Consulenza
              <ArrowUpRight className="ml-1 size-4" />
            </Link>
          </Button>

          <Button asChild variant="outline" size="lg" className="bg-transparent border border-foreground/40 text-foreground hover:bg-foreground/10 hover:text-foreground rounded-lg px-8 py-7 text-base">
            <Link to="/ProfilePage">
              <Download className="mr-1 size-4" />
              Scarica Curriculum
            </Link>
          </Button>
        </div>

        {}
        <div ref={footerRef} className={`transition-all duration-1000 delay-700 ease-out ${footerVisible ? "opacity-100" : "opacity-0"}`}>
          <div className="flex items-center justify-center gap-6 max-w-3xl mx-auto">
            <div className="h-px flex-1 bg-border" />
            <span className="font-mono text-xs tracking-[0.25em] uppercase text-muted-foreground whitespace-nowrap">
              DOTT. MIRKO COLLOCA · Eccellenza Medica · Dal 2009
            </span>
            <div className="h-px flex-1 bg-border" />
          </div>
        </div>
      </div>
    </section>;
}